import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ThankYouView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h4" component='h1' id="main-heading" tabIndex={-1}>{t('All tasks completed')}</Typography>
      <div style={{ textAlign: 'center' }}>
        <img src="/assets/images/b2ai-thank-you.jpg" alt="Thank you" style={{maxHeight: '30rem'}} />
      </div>
    </>
  );
}
